/* 
Sample upsert request (no photosPending and photosApproved attributes)
{
  "id": "00000000-2222-0000-4444-41e7da2a327b",
  "recordType": "PProvShow",
  "venue": "Comedy Sportz",
  "photoUploadEnabled": true,
  "showDate": "2025-03-11",
  "audienceAppUrl": "https://audience.mr-sandbox.net/?show=00000000-2222-0000-4444-41e7da2a327b"
}
*/
import constants from './constants.mjs';

export class pProvShow {
  constructor(data) {
    this.id = data.id || crypto.randomUUID(); // generate new uuid if not provided
    this.recordType = constants.DDB_RECORD_TYPES.SHOW; // string, should always be PProvShow
    this.venue = data.venue || '(venue)'; // string
    this.showDate = data.showDate || '19:00'; // string, default to 7:00PM
    this.photoUploadEnabled = data.photoUploadEnabled || true; // boolean
    this.audienceAppUrl = data.audienceAppUrl || '(audienceAppUrl)'; // string
    this.pendingPhotos = data.pendingPhotos  || 0;
    this.approvedPhotos = data.approvedPhotos || 0;

    // Validate the data
    this.validate();
  }

  showDateWithWeekday() {
    return new Date(this.showDate).toLocaleDateString('en-US', {
        weekday: 'short', month: 'numeric', day: 'numeric', year: 'numeric', timeZone: 'UTC'
    });
  }

  showDateShort() {
    return new Date(this.showDate).toLocaleDateString('en-US', {
        month: 'numeric', day: 'numeric', year: 'numeric', timeZone: 'UTC'
    });
  }

  validate() {
    if (!this.id) {
      throw new Error("id is required");
    }
    if (typeof this.id !== 'string') {
        throw new Error("id must be a string");
    }
    if (!this.venue) {
      throw new Error("venue is required");
    }
    if (typeof this.venue !== 'string') {
        throw new Error("venue must be a string");
    }
    if (!this.showDate) {
      throw new Error("showDate is required");
    }
    if (typeof this.audienceAppUrl !== 'string') {
        throw new Error("audienceAppUrl must be a string");
    }
  }
}

